package org.hs_soft.runmynesto.pages.login.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.jetbrains.compose.web.css.percent

@Composable
fun ForgetPasswordSendCode(
    email:String,
    info:String,
    loading:Boolean,
    onEmailChange:(String)->Unit,
    onCancelClick:()->Unit,
    onSubmitClick:()->Unit,
)
{
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SpanText(
            text = info,
            modifier = Modifier
                .margin(top= Dimen.largePadding)
                .color(Theme.TextSecondary.rgb)
                .textAlign(TextAlign.Center)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Normal)
                .fontSize(FontSizes.mediumFontSize)
                .lineHeight(100.percent)
        )

        Spacer()

        CustomEditText(
            modifier = Modifier,
            label = Strings.current().email,
            value = email,
            isRequired = true,
            hint ="",
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                onEmailChange(it)
            },
        )


        LoginSubmitButton(
            tvTitle = Strings.current().cancel,
            buttonTitle = Strings.current().sendCode,
            loading = loading,
            isClickable = email.isNotEmpty(),
            onButtonClick ={
                onSubmitClick()
            },
            onTitleClick = {
                onCancelClick()
            }
        )


    }


}